import { useEffect, useState } from "react"
import Button from "../../../components/UI/Button/Button"
import Select from "../../../components/UI/Select/Select"
import fetchData from "../../../shared/fetchData"
import { toast } from "react-toastify"

const CancelOrder = (props) => {
    const [cancelReasons, setCancelReasons] = useState([])
    const [cancelReason, setCancelReason] = useState('')
    const [invalidSelect, setInvalidSelect] = useState(false)

    useEffect(() => {
        var info = {
            "version": "mtpx001"
        }
        var raw = JSON.stringify(info)
        var url = 'management/api/v1/orders/getCancelReasons'
        fetchData(raw, url).then(response => response.json())
            .then(result => {
                setCancelReasons(result.cancelReasons)
            })
            .catch(error => console.log(error))
    }, [])
    const changeCancelReason = (selectedOption) => {
        console.log(selectedOption);
        setCancelReason(selectedOption)
    }
    const cancelOrderSubmit = (event) => {
        let valid = true
        if (cancelReason == null || cancelReason == '') {
            valid = false
            setInvalidSelect(true)
        }
        if (valid) {
            var info = {
                "orderId": props.orderId,
                "reasonId": cancelReason != null && cancelReason != '' ? cancelReason.value : '',
                "version": "mtpx001"
            }
            var raw = JSON.stringify(info)
            var url = 'management/api/v1/orders/cancelOrder'
            fetchData(raw, url).then(response => response.json())
                .then(result => {
                    if (result.status == 0) {
                        props.closeModalAndUpdateGrid()
                    } else {
                        if (result.message == 'INVALID_INPUT') {
                            toast.error('اطلاعات معتبر نیست');
                        } else if (result.message == 'TIMEOUT_CANCEL') {
                            toast.error('مهلت کنسل کردن سفارش گذشته است')
                        } else if (result.message == 'INVALID_STATE') {
                            toast.error('وضعیت سفارش صحیح نیست')
                        }
                    }
                })
                .catch(error => console.log(error))
        }
    }
    let reasonList = []
    if (cancelReasons != null && cancelReasons.length != 0) {
        cancelReasons.map(b => {
            reasonList.push({
                value: b.id,
                label: b.description,
                hasComment: b.hasComment,
            })
        })
    }
    return (


        <div>
            <div className="row justify-content-center">
                <Select
                    name="form-field-name"
                    value={cancelReason}
                    placeholder="علت کنسلی"
                    inModal={true}
                    className={invalidSelect && (cancelReason == null || cancelReason == '') ? 'invalid-select' : ''}
                    options={reasonList}
                    onChange={changeCancelReason}
                    col="12"
                />
            </div>
            <div className="row justify-content-center mt-3">
                <div className="col-6">
                    <Button btnType="General" clicked={() => props.back()} >خیر</Button>
                </div>
                <div className="col-6">
                    <Button btnType="Success" clicked={cancelOrderSubmit} >بله</Button>
                </div>
            </div>
        </div>
    )
}

export default CancelOrder;